import { Injectable, signal } from '@angular/core';
import {IExecutorPoint, IMapPoint} from '@lib-typing/map-point.interface';
import { IOrder } from '@lib-typing/order.interface';
import { EnumTranslateService } from '@lib-services/enum-translate.service';
import {IPerson} from '@lib-typing/person.interface';
import { PersonStatusEnum } from '@libs-enums/status.enum';

@Injectable({
    providedIn: 'root'
})
export class MapService {
    points = signal<IMapPoint[]>([]);
    activeOrders = signal<IMapPoint[]>([]);
    executorsLocations = signal<IExecutorPoint[]>([]);

    constructor(private enumTranslateService: EnumTranslateService,) {}

    addMapPoints(orders: IOrder[]): void {
        this.points.set(orders.map((order) => {
            if (!order || !order.contact || !order.location?.latitude || !order.location?.longitude) {
                return {} as IMapPoint;
            }

            return {
                orderId: order.id,
                queueNumber: order.queueNumber,
                preset: 'islands#blueIcon',
                coordinates: [Number(order.location.latitude.toFixed(6)), Number(order.location.longitude.toFixed(6))],
                label: `
                Заявка: ${order.id.toString()};
                Адрес: ${order.location.address};
                Исполнитель: ${order.executor?.id}, ${order.executor?.lastName};
                Статус: ${this.enumTranslateService.translateStatus(order.status)}`,
            } as IMapPoint;
        }));
    }

    addExecutorsPoints(workers: IPerson[]): void {
        this.executorsLocations.set(workers.filter(worker => worker.status === PersonStatusEnum.active).map((worker) => {
            if ((!worker || !worker.firstName || !worker.lon || !worker.lat)) {
                return {} as IExecutorPoint;
            }
            return {
                workerId: worker.id,
                workerName: `${worker.firstName} ${worker.lastName || ''}`,
                coordinates: [Number(worker.lat.toFixed(6)), Number(worker.lon.toFixed(6))],
            } as IExecutorPoint;
        }));
    }

    addActiveOrders(orders: IOrder[]): void {
        this.activeOrders.set(orders.map((order) => {
            if (!order || !order.contact || !order.location?.latitude || !order.location?.longitude) {
                return {} as IMapPoint;
            }

            return {
                orderId: order.id,
                coordinates: [Number(order.location.latitude.toFixed(6)), Number(order.location.longitude.toFixed(6))],
                label: `
                Заявка: ${order.id.toString()};
                Адрес: ${order.location.address};
                Статус: ${this.enumTranslateService.translateStatus(order.status)}`,
            } as IMapPoint;
        }));
    }
}
